module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product11-1ba9a29f9e1d5bfcbd46a50c468c0cf0.jpg";